import React from 'react';
import { RotateCcw } from 'lucide-react';

export const Refund = () => {
  return (
    <div className="min-h-screen py-20 bg-gradient-to-br from-hr-warm-bg via-white to-hr-teal-light/10 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-hr-teal/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-hr-purple/5 rounded-full blur-3xl animate-float-slow" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12 animate-fade-in-up">
          <header className="mb-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-hr-teal-light mb-6 animate-bounce-subtle">
              <RotateCcw className="h-8 w-8 text-hr-teal" />
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-hr-text-primary mb-4 animate-fade-in-up stagger-1" style={{ opacity: 0 }}>
              Refund & Cancellation Policy
            </h1>
            <p className="text-hr-text-muted animate-fade-in-up stagger-2" style={{ opacity: 0 }}>Last Updated: 1/15/2026</p>
          </header>

          <div className="prose prose-lg max-w-none text-hr-text-secondary animate-fade-in-up stagger-3" style={{ opacity: 0 }}>
            <p className="lead">
              HR Nest, LLC ("HR Nest," "we," "us," or "our") values transparency and fairness. This Refund & Cancellation Policy outlines the terms under which refunds, cancellations, and rescheduling may occur for our services, programs, digital products, and events.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Digital Products & Downloadable Resources</h2>
            <p>
              Due to the digital nature of our downloadable products (including templates, guides, toolkits, and other digital resources), <strong>all sales are final</strong>.
            </p>
            <p>
              Once a digital product has been accessed or downloaded, no refunds, exchanges, or cancellations will be issued.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Coaching, Programs & Services</h2>
            
            <h3 className="font-heading text-xl font-semibold text-hr-text-primary mt-8 mb-3">One-on-One Coaching / Consulting</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Cancellations or rescheduling requests must be made at least 24 hours in advance.</li>
              <li>Missed sessions or late cancellations may be forfeited without refund.</li>
              <li>Refunds are not guaranteed once services have commenced.</li>
            </ul>

            <h3 className="font-heading text-xl font-semibold text-hr-text-primary mt-8 mb-3">Group Programs, Workshops & Bootcamps</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Refund eligibility (if any) will be clearly stated on the registration page.</li>
              <li>Once a program has started, no refunds will be issued.</li>
              <li>HR Nest reserves the right to cancel or reschedule programs due to low enrollment or unforeseen circumstances. In such cases, participants may receive a refund or credit at HR Nest's discretion.</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Events & Conferences</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Event tickets are non-refundable unless otherwise stated.</li>
              <li>If an event is canceled by HR Nest, registrants will be offered a refund, credit, or transfer.</li>
              <li>HR Nest is not responsible for travel, lodging, or related expenses.</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Chargebacks</h2>
            <p>
              Initiating a chargeback without first contacting HR Nest may result in suspension of access to services and future purchases.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Contact for Refund Questions</h2>
            <p>📧 HRnestllc@gmail.com</p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Refund;
